<template>
  <div>
    <template>
      <h4
          class="not-margin"
          :style="{
          fontWeight: 'bold',
          color: '#195BFF',
          fontSize: '18px',
          marginTop: '10px',
        }"
      >
        <i
            class="fal fa-info-circle"
            :style="{ width: '30px', fontSize: '18px' }"
        ></i>
        {{ $t('generalCustomer.general_customer_info_title') }}
      </h4>
    </template>

    <!-- name -->
    <div class="columns" style="margin-top: 10px; margin-left: 0; margin-right: 0;">
      <div class="field column">
        <div class="control">
          <label class="label">
            {{ $t('generalCustomer.name') }}
            <span class="text-danger">* {{ errors.first("name") }}</span>
            <span class="text-danger">
              {{ server_errors.name }}
            </span>
          </label>
          <input
              class="input"
              type="text"
              name="name"
              :placeholder="$t('generalCustomer.placeholder_enter_first')"
              v-model="listCustomer.customer_name"
              v-validate="'required|max:191'"
          />
        </div>
      </div>

      <!-- surname -->
      <div class="field column">
        <div class="control">
          <label class="label">
            {{ $t('generalCustomer.surname') }}
            <span class="text-danger"
            >* {{ errors.first("surname") }}</span
            >
            <span class="text-danger">
              {{ server_errors.surname }}
            </span>
          </label>
          <input
              class="input"
              type="text"
              name="surname"
              :placeholder="$t('generalCustomer.placeholder_enter_first')"
              v-model="listCustomer.customer_surname"
              v-validate="'required|max:191'"
          />
        </div>
      </div>

      <!-- tel -->
      <div class="field column">
        <label class="label" style="text-align: left">
          {{ $t('generalCustomer.tel') }}
          <span class="text-danger">* {{ errors.first("tel") }}</span>
          <span class="text-danger">
            {{ server_errors.tel }}
          </span>
        </label>
        <div class="field has-addons">
          <p class="control">
            <span class="select">
              <select style="min-width: 80px" v-model="telType">
                <option value="020">020</option>
                <option value="030">030</option>
              </select>
            </span>
          </p>
          <p class="control" style="flex: auto">
            <input
                class="input"
                type="text"
                name="tel"
                placeholder="XXXXXXX..."
                v-model="listCustomer.customer_tel"
                v-validate="{
                required: true,
                numeric: true,
                max: telType === '020' ? 8 : 7,
                min: telType === '020' ? 8 : 7,
              }"
            />
          </p>
        </div>
      </div>
    </div>

    <!-- ແຂວງ -->
    <div class="columns" style="margin-top: 10px; margin-left: 0; margin-right: 0;">
      <div class="field column">
        <div class="control">
          <label class="label">
            {{ $t('generalCustomer.province') }}
            <span class="text-danger"> {{ errors.first("province") }}</span>
          </label>
          <div class="select">
            <select
                v-model="listCustomer.province_id"
                :placeholder="$t('generalCustomer.placeholder_province')"
                name="province"
            >
              <option
                  :value="province.id"
                  v-for="(province, index) in provinces"
                  :key="index"
              >
                {{ province.name }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <!-- ເມືອງ -->
      <div class="field column">
        <div class="control">
          <label class="label">
            {{ $t('generalCustomer.district') }}
            <span class="text-danger"> {{ errors.first("district") }}</span>
          </label>
          <div class="select">
            <select
                v-model="listCustomer.district_id"
                :placeholder="$t('generalCustomer.placeholder_district')"
                name="district"
            >
              <option
                  :value="district.id"
                  v-for="(district, index) in districts"
                  :key="index"
              >
                {{ district.name }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <!-- village -->
      <div class="field column">
        <div class="control">
          <label class="label">
            {{ $t('generalCustomer.village') }}
            <span class="text-danger"> {{ errors.first("village") }}</span>
            <span class="text-danger">
              {{ server_errors.village }}
            </span>
          </label>
          <input
              class="input"
              name="village"
              :placeholder="$t('generalCustomer.placeholder_village')"
              v-model="listCustomer.village_name"
              v-validate="'max:191'"
          />
        </div>
      </div>
    </div>

    <!-- profile_picture -->
    <div class="field column">
      <div class="control">
        <label class="label">{{ $t('generalCustomer.choose_profile_label') }}
          <span class="text-danger">* {{ errors.first('profile_picture') }}</span>
          <span class="text-danger">{{ server_errors.profile_picture }}</span>
        </label>
        <div class="box-upload-file" @click="triggerInputClick()" v-if="!images.base64">
          <div class="text-msg">
            <i class="fal fa-cloud-upload"></i>
            <p class="choose">
              {{ $t('generalCustomer.choose_profile_hint') }}
            </p>
          </div>
        </div>
        <div class="has-profile" @click="triggerInputClick()" :style="{ backgroundImage: `url(${images.base64})`}"
             v-if="images.base64"></div>

        <div v-show="false" class="control">
          <input
              @change="onFileChange" ref="file"
              class="input input-ctn" type="file" name="profile_picture"
              v-validate="'mimes:image/*|size:5120'"
          >
        </div>
      </div>
    </div>


    <div ref="target" id="target" class="center">
      <div class="con-btns">
        <vs-button
            ref="button"
            flat
            @click="ValidateForm()"
            class="form-btn-loading"
        >{{ $t('generalCustomer.edit_customer_button') }}
        </vs-button>
      </div>
    </div>
  </div>
</template>
<script>
import {Validator} from "vee-validate";

export default {
  props: ["listCustomer"],
  data() {
    return {
      active: false,
      isLoading: false,
      server_errors: {
        name: "",
        surname: "",
        tel: "",
        profile_picture: "",
      },
      telType: "",
      images: {
        fileName: '',
        base64: '',
        size: '',
        file: '',
        type: '',
      },
      provinces: [],
      districts: [],
      filterDistricts: [],
      profile: "",
    };
  },
  methods: {
    ValidateForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.EditData();
        }
      });
    },
    EditData() {

      this.btnLoading = true;
      const formData = new FormData();
      const data = this.listCustomer;
      data.name = this.listCustomer.customer_name;
      data.surname = this.listCustomer.customer_surname;
      data.tel = this.listCustomer.customer_tel;
      data.village_id = this.listCustomer.village_name;
      data.profile_picture = null;
      data.district_id = this.listCustomer.district_id;
      data.province_id = this.listCustomer.province_id;
      Object.keys(data)
          .forEach((keyVal) => {
            if (data[keyVal] == null || typeof data[keyVal] === 'undefined') {
              data[keyVal] = '';
            }
            formData.append(keyVal, data[keyVal]);
          });
      if (this.profile) {
        formData.append('profile_picture', this.profile);
      }
      formData.append('_method', 'put');
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      }
      this.$http.post('admin-edit-customer/' + this.listCustomer.id, formData, config).then((res) => {
        if (res.data.success) {
          setTimeout(() => {
            this.$emit('close');
            this.$emit('success');
            this.$notification.OpenNotification_AddItem_OnSuccess('top-right', 'dark', 3000);
          }, 300);
        }
      }).catch((error) => {
        this.btnLoading = false;
        if (error.response.status === 422) {
          var obj = error.response.data.errors;       // ໃຊ້ການລູບຂໍ້ມູນເພາະວ່າຂໍ້ມູນ errors ທີ່ສົ່ງມາຈາກ Server ນັ້ນເປັນ Array Object
          for (let [key, value] of Object.entries(obj)) {
            this.server_errors[key] = value[0];
          }
        }
      });
    },


    BtnLoading() {
      return this.$vs.loading({
        target: this.$refs.button,
        scale: "0.6",
        background: "primary",
        opacity: 1,
        color: "#fff",
      });
    },

    triggerInputClick() {
      let selector = this.$refs.file;
      if (selector) {
        selector.click();
      }
    }, // Trigger-Click
    async onFileChange(e) {
      this.profile = e.target.files[0];
      const file = e.target.files[0];
      const FileSize = (file.size / 1024 / 1024).toFixed(2);
      const extensions = file.type.split("/");
      const validate_Ext = this.ValidateExtensions(extensions[1]);

      if (validate_Ext === true && FileSize < 6) {
        this.images.file = file;
        this.images.type = extensions[1];
        this.images.size = this.FormatByte(file.size);
        this.images.base64 = await this.ToBase64(file);
      }
    }, // OnFile-Change

    ToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    }, // Convert-Base64

    FormatByte(bytes) {
      var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      if (bytes == 0) return '0 Byte';
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
    }, // FormatByte

    ValidateExtensions(ext) {
      if (ext == 'jpg' || ext == 'jpeg' || ext == 'png' || ext == 'gif' || ext == 'bmp') {
        return true;
      } else {
        return false;
      }
    },

    FetchAddress() {
      this.$http.get('list-address').then(res => {
        const items = res.data;
        this.provinces = items.provinces;
        this.filterDistricts = items.districts;
        this.FilterDistricts(this.listCustomer.province_id);
      }).catch(() => {

      });
    },

    FilterDistricts(provinceID) {
      const result_checking = this.filterDistricts.filter(item => {
        if (item.province_id == provinceID) {
          return item;
        }
      });
      this.districts = result_checking;
    },


  },
  watch: {
    "listCustomer.customer_tel": function () {
      this.server_errors.tel = "";
    },
    'listCustomer.province_id': function (provinceID) {
      this.FilterDistricts(provinceID);
    },
  },

  created() {
    const dict = {
      custom: {
        name: {
          required: `(${this.$t('validator.required')}...)`,
          max: `(${this.$t('validator.max_character', {max: 191})}...)`,
        },

        surname: {
          required: `(${this.$t('validator.required')}...)`,
          max: `(${this.$t('validator.max_character', {max: 191})}...)`,
        },

        tel: {
          required: `(${this.$t('validator.required')}...)`,
          numeric: `(${this.$t('validator.numeric')}...)`,
          max: (name, rules) => {
            return `(${this.$t('validator.limit_character', {length: rules[0]})}...)`;
          },
          min: (name, rules) => {
            return `(${this.$t('validator.limit_character', {length: rules[0]})}...)`;
          },
        },

        profile_picture: {
          mimes: this.$t('generalCustomer.validation_file_type_invalid'),
          size: this.$t('generalCustomer.validation_file_size_max_5mb'),
        },
      },
    };
    Validator.localize("en", dict);
    this.images.base64 = this.listCustomer.profile_picture;
    if (this.listCustomer.customer_tel.length === 8) {
      this.telType = "020"
    } else {
      this.telType = "030"
    }
    this.FetchAddress();
  }
};
</script>

<style lang="scss" scoped>
.box-upload-file {
  border: 1px dashed rgba(100, 98, 98, 0.867);
  height: 200px;
  width: 100%;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  border-radius: 5px;

  &:hover {
    cursor: pointer;
    border: 1px dashed $primary-color;

    .text-msg {
      i {
        color: $primary-color;
      }

      p {
        color: $primary-color;
      }
    }
  }

  .text-msg {
    i {
      font-size: 25px;
      color: rgba(100, 98, 98, 0.867);
    }

    .choose {
      margin-top: 10px;
      color: rgba(100, 98, 98, 0.867);
    }
  }
}

.has-profile {
  border: none;
  height: 200px;
  width: 100%;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  background-repeat: no-repeat;
  background-size: 300px;
  background-position: center;

  &:hover {
    cursor: pointer;
  }
}

.field:not(:last-child) {
  margin-bottom: 0;
}

.column {
  display: block;
  flex-basis: 0;
  flex-grow: 1;
  flex-shrink: 1;
  padding: 0.35rem;
}

</style>